const hamburger = document.querySelector('.hamburger')
const hamburgerIcon = document.querySelector('.hamburger .icon-hamburger')
const close = document.querySelector('.hamburger .icon-close')
const nav = document.querySelector('.header__inline-menu')


hamburger.addEventListener('click', ()=>{
  hamburger.classList.toggle('open');
  nav.classList.toggle('open')
})

function openHangingForm(){
   const hangingWrapper = document.querySelector('.hanging-form');
   const hangingBtn = document.querySelector('.hanging_form_btn')
   let flag = false;
  if(hangingBtn){
   hangingBtn.addEventListener('click', ()=>{
     if(!flag){
       hangingWrapper.classList.add('open');
       flag = true;
       
     }else{
       hangingWrapper.classList.remove('open');
        flag = false;
     }
   })
  }
}

openHangingForm()


// gallery js


document.addEventListener('DOMContentLoaded', ()=>{

    const gallery = document.querySelector('.light-box-galley');

   if(gallery){
    const lightbox = document.getElementById('lightbox');
    const lightboxImage = document.getElementById('lightbox-image');
    const closeButton = document.getElementById('close');
    
    // Add event listener to each image
    gallery.addEventListener('click', e => {
      if (e.target.classList.contains('gallery-image')) {
        const imageSrc = e.target.src;
        console.log(imageSrc)
        lightboxImage.src = imageSrc;
        lightbox.style.display = 'flex';
      }
    });
    
    // Close lightbox when close button is clicked
    closeButton.addEventListener('click', () => {
      lightbox.style.display = 'none';
    });
    
    // Close lightbox when clicking outside the image
    lightbox.addEventListener('click', e => {
      if (e.target === lightbox) {
        lightbox.style.display = 'none';
      }
    });
   }
  

})
